"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Textarea: function() {
        return _Textarea.Textarea;
    },
    renderTextarea_unstable: function() {
        return _Textarea.renderTextarea_unstable;
    },
    textareaClassNames: function() {
        return _Textarea.textareaClassNames;
    },
    useTextareaStyles_unstable: function() {
        return _Textarea.useTextareaStyles_unstable;
    },
    useTextarea_unstable: function() {
        return _Textarea.useTextarea_unstable;
    }
});
const _Textarea = require("./Textarea");
